// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.heading {
  padding: 0.7rem 0.5rem;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  background-color: #6564DB;
  color: white;
  font-weight: 500;
  font-size: 16px;
  font-family: "Roboto", "Helvetica Neue", Arial, Tahoma;
}

.heading2 {
  padding-bottom: 0;
  margin-top: 0;
  font-weight: 500;
  font-size: 16px;
  font-family: "Roboto", "Helvetica Neue", Arial, Tahoma;
}

.consensus-header {
  border-left-width: 1px;
  border-right-width: 1px;
}

.consensus-header-border-left {
  border-left-width: 1px;
}

.consensus-header-border-right {
  border-right-width: 1px;
}

.consensus-table-border-left {
  border-left-width: 1px;
  border-color: lightgray;
}

.consensus-table-border-right {
  border-right-width: 1px;
  border-color: lightgray;
}

.threshold {
  font-family: "Roboto", "Helvetica Neue", Arial, Tahoma;
  font-size: 16px;
  font-weight: 500;
  margin-top: 0;
  padding-bottom: 0;
}

.pathogen {
  color: #A68F26;
  font-weight: 600;
}
.pathogen:hover {
  color: #d9c259;
  font-weight: 600;
}

.host {
  color: #F06543;
  font-weight: 600;
}
.host:hover {
  color: #f69f8a;
  font-weight: 600;
}

.interactor {
  color: rgb(49, 162, 49);
  font-weight: 600;
}
.interactor:hover {
  color: rgb(36, 186, 236);
  font-weight: 600;
}

.intmodal {
  align-items: center;
}

.modal-backdrop {
  background-color: rgba(0, 0, 0, 0) !important;
}

.tdd {
  width: 30px;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/pages/Result/Results.scss","webpack://./src/scss/colors.scss"],"names":[],"mappings":"AAGA;EACE,sBAAA;EACA,4BAAA;EACA,6BAAA;EACA,yBCHU;EDIV,YAAA;EACA,gBAAA;EACA,eAAA;EACA,sDAAA;AAFF;;AAKA;EAEE,iBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,sDAAA;AAHF;;AAMA;EACE,sBAAA;EACA,uBAAA;AAHF;;AAMA;EACE,sBAAA;AAHF;;AAMA;EACE,uBAAA;AAHF;;AAMA;EACE,sBAAA;EACA,uBAAA;AAHF;;AAMA;EACE,uBAAA;EACA,uBAAA;AAHF;;AAMA;EACE,sDAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;AAHF;;AAMA;EACE,cCtCc;EDuCd,gBAAA;AAHF;AAIE;EACE,cCxCkB;EDyClB,gBAAA;AAFJ;;AAMA;EACE,cCjDU;EDkDV,gBAAA;AAHF;AAIE;EACE,cCnDc;EDoDd,gBAAA;AAFJ;;AAMA;EACE,uBAAA;EACA,gBAAA;AAHF;AAKE;EACE,wBAAA;EACA,gBAAA;AAHJ;;AAQA;EACE,mBAAA;AALF;;AASA;EACE,6CAAA;AANF;;AASA;EACE,WAAA;EACA,gBAAA;AANF","sourcesContent":["@import '../../scss/colors';\n@import '../../scss/globals';\n\n.heading {\n  padding: 0.7rem 0.5rem;\n  border-top-left-radius: 12px;\n  border-top-right-radius: 12px;\n  background-color: $palette-2;\n  color: white;\n  font-weight: 500;\n  font-size: 16px;\n  font-family: \"Roboto\", \"Helvetica Neue\", Arial, Tahoma;\n}\n\n.heading2 {\n\n  padding-bottom: 0;\n  margin-top: 0;\n  font-weight: 500;\n  font-size: 16px;\n  font-family: \"Roboto\", \"Helvetica Neue\", Arial, Tahoma;\n}\n\n.consensus-header {\n  border-left-width: 1px;\n  border-right-width: 1px;\n}\n\n.consensus-header-border-left {\n  border-left-width: 1px;\n}\n\n.consensus-header-border-right {\n  border-right-width: 1px;\n}\n\n.consensus-table-border-left {\n  border-left-width: 1px;\n  border-color: lightgray;\n}\n\n.consensus-table-border-right {\n  border-right-width: 1px;\n  border-color: lightgray;\n}\n\n.threshold {\n  font-family: \"Roboto\", \"Helvetica Neue\", Arial, Tahoma;\n  font-size: 16px;\n  font-weight: 500;\n  margin-top: 0;\n  padding-bottom: 0;\n}\n\n.pathogen {\n  color: $text-pathogen;\n  font-weight: 600;\n  &:hover {\n    color: $text-pathogen-light;\n    font-weight: 600;\n  }\n}\n\n.host {\n  color: $text-host;\n  font-weight: 600;\n  &:hover {\n    color: $text-host-light;\n    font-weight: 600;\n  }\n}\n\n.interactor {\n  color: rgb(49, 162, 49);\n  font-weight: 600;\n\n  &:hover {\n    color: rgb(36, 186, 236);\n    font-weight: 600;\n\n  }\n}\n\n.intmodal {\n  align-items: center;\n\n}\n\n.modal-backdrop {\n  background-color: rgba(0, 0, 0, 0) !important;\n}\n\n.tdd {\n  width: 30px;\n  overflow: hidden;\n}","\n$black: #011627;\n$white: #FFFFFF;\n$palette-1:#2a9679;\n$palette-2: #6564DB;\n$palette-3: #FAF9F6;\n\n$palette-1-dark: darken($palette-1, 5%);\n$palette-1-light: lighten($palette-1, 10%);\n$palette-2-dark: darken($palette-2, 10%);\n$palette-2-light: lighten($palette-2, 10%);\n$palette-3-dark: darken($palette-3, 5%);\n$palette-3-darker: darken($palette-3, 10%);\n$palette-3-light: lighten($palette-3, 10%);\n\n$text-host: #F06543;\n$text-host-light: lighten($text-host, 15%);\n$text-pathogen: #A68F26;\n$text-pathogen-light: lighten($text-pathogen, 20%);\n\n$nav-outline: #ffffff;\n$nav-outline-hvr: #ffffff;\n\n$text-ghost: #b4b4b4;\n$text-light:#ffffff;\n$text-main: #393939;\n$text-hard: #212121;\n\n$color-light-grey: #c9c9c9;\n\n$palette-1-v-light: #abeef0;\n\n$palette-1-bg: #e2fcfc;\n$palette-2-bg: #ffe4eb;\n\n$chip-bg: #def5ff;\n$chip-font: #036778;\n\n$palette-1-pastel: #a9fafc;\n\n// $nav-back:#4fa2a2;\n$nav-back:#288DC2;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
